/* eslint-disable max-len */
import debug from 'debug';
import classRoomStore from 'store/classRoomStore';
import { hasVerifiedRobotNumber } from 'store/robotSelection';
import userStore from 'store/userStore';

const log = debug('ui:mqtt');

/**
 * Listen the topic and execute the executor function.
 * This will called when some commend received the status update
 *
 * @function
 * @memberof Mqtt.CommandStatus#
 * @ignore
 * @param {KaisClanSchemaCommandStatus} packet - The payload in JSON structure.
 * @see {@link Mqtt.CommandStatus.schema JSON structure}
 * @todo Remove current command from queue, payload.id
 * @todo Execute the next command in queue if exist
 */
export const executor = (packet) => {
  if (userStore.isStudent) return;

  const { payload, topic } = packet;

  const {
    mac, identifier,
  } = payload;

  const { classRoomCode } = classRoomStore;
  const session = classRoomStore._robotReconciliationSession;
  if (!session || session.code !== classRoomCode || !Number.isSafeInteger(identifier) || identifier < 0) return;
  if (topic !== `to/classroom/${classRoomCode}/register_feedback` &&
      topic !== `to/classroom/${classRoomStore.classRoomSSID}/register_feedback`) return;
  // Feedback is an acknowledgment, never evidence for a registration claim.
  // Physical matching or a camera report must establish the mapping first.
  const current = classRoomStore.getRobotByMacId(mac);
  if (!hasVerifiedRobotNumber(current) || String(current.identifier) !== String(identifier)) return;
  const registration = classRoomStore.registeringRobots.get(mac);
  if (registration && String(registration.identifier) === String(identifier)) {
    log('Remove %s from registering list', mac);
    classRoomStore.registeringRobots.delete(mac);
  }
};

export default executor;
